export const WORKSCORE_ASSESSMENTS = [
  {
    id: 'salesforce',
    slug: 'salesforce',
    title: 'Salesforce AI WorkScore',
    role: 'Field Sales Executive / B2B-B2C Sales / Relationship Builder',
    color: '#0071e3',
    icon: '🎯',
    estimatedMinutes: 90,
    questionsPerSection: 10,
    sectionTitles: [
      'Lead Generation & Prospecting',
      'Sales Communication & Pitching',
      'Negotiation & Objection Handling',
      'Relationship Building & Follow-Ups',
      'Target Pressure & Sales Strategy'
    ]
  },
  {
    id: 'customercare',
    slug: 'customercare',
    title: 'CustomerCare AI WorkScore',
    role: 'Support Executive / Service Representative / Complaint Resolution',
    color: '#30d158',
    icon: '🎧',
    estimatedMinutes: 90,
    questionsPerSection: 10,
    sectionTitles: [
      'Customer Communication & Listening',
      'Complaint Resolution',
      'Emotional Intelligence & Empathy',
      'Service Recovery & Retention',
      'Pressure Handling & Professionalism'
    ]
  },
  {
    id: 'callingsales',
    slug: 'callingsales',
    title: 'CallingSales AI WorkScore',
    role: 'Telecaller / Inside Sales / SDR / Outbound Sales Caller',
    color: '#ff9f0a',
    icon: '📞',
    estimatedMinutes: 90,
    questionsPerSection: 10,
    sectionTitles: [
      'Cold Calling & Introductions',
      'Phone Communication Skills',
      'Objection Handling Over Calls',
      'Lead Conversion & Follow-Ups',
      'High-Pressure Calling Environment'
    ]
  },
  {
    id: 'feetonstreet',
    slug: 'feetonstreet',
    title: 'FeetOnStreet AI WorkScore',
    role: 'Field Promoter / Direct Marketing / Territory Sales',
    color: '#ff375f',
    icon: '🏃',
    estimatedMinutes: 90,
    questionsPerSection: 10,
    sectionTitles: [
      'Public Interaction & Confidence',
      'Product Demonstration & Promotion',
      'Field Challenges & Adaptability',
      'Lead Collection & Territory Strategy',
      'Persistence, Targets & Ground Pressure'
    ]
  }
];

export const getWorkscoreConfig = (slug) => WORKSCORE_ASSESSMENTS.find((item) => item.slug === slug);
